import { of } from 'rxjs';
import { AbstractTokenService } from './abstract-token.service';
import { Uuid } from '../utils/uuid.utils';
import { oauthLogger } from '../utils/logging.utils';
export class CorrelationidService extends AbstractTokenService {
  appendOptions(data, finalOptions) {
    oauthLogger.info('Correlation-ID wurde erzeugt und wird dem Request hinzugefügt.');
    const headers = finalOptions.headers;
    headers.set(CorrelationidService.HEADER_NAME_CORRELATION_ID, data);
    finalOptions.headers = headers;
    return finalOptions;
  }
  fetchToken(config) {
    oauthLogger.info('Correlation-ID wird ermittelt.');
    return (config === null || config === void 0 ? void 0 : config.verfahrenId) ? of(config.verfahrenId + '-' + Uuid.uuid()) : of(Uuid.uuid());
  }
  resetToken() {
    // Eine Correlation-ID ist pro Anfrage "einzigartig" und darf nicht gecachet werden!
  }
  resetBy(_config) {
    this.resetToken();
  }
}
CorrelationidService.HEADER_NAME_CORRELATION_ID = 'Correlation-ID';
//# sourceMappingURL=correlationid.service.js.map
